var _line, _line2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 115,
    viewBox: "0 0 222 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.00292969,
    y1: 52.7672,
    x2: 67.0012,
    y2: 52.7672,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 179.999,
    y1: 115,
    x2: 222.011,
    y2: 115,
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 171.004H68.5",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 150.194L161.617 149.724C140.258 189.894 101.869 218.24 57.1925 226.83L47.8336 228.629C84.3208 157.267 84.3175 72.7111 47.8237 1.35152L55.3101 2.72595C100.306 10.9867 139.278 38.8726 161.619 78.7933L171.112 97.1194L180.369 114.99L161.62 149.719L162.5 150.194Z",
    fill: "",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOr);
export default __webpack_public_path__ + "static/media/or.658df4989172d6e4dee5058d0f6f8a93.svg";
export { ForwardRef as ReactComponent };